import { render } from "./B2bTimelineExtend.vue?vue&type=template&id=4b653d62&scoped=true&lang=pug"
import script from "./B2bTimelineExtend.vue?vue&type=script&lang=js"
export * from "./B2bTimelineExtend.vue?vue&type=script&lang=js"

import "./B2bTimelineExtend.vue?vue&type=style&index=0&id=4b653d62&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b653d62"]])

export default __exports__